import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { getResourceIcon } from '../helpers/iconHelper';
import { resourceDisplayName } from '../utils/resourceName';
import AnimationCircle from './AnimationCircle';

// Phone app-bar trigger for the market picker.
export default function MarketChip({ resource, attention, onClick }) {
  const name = resourceDisplayName(resource);
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={`Change market, current ${name || 'none'}`}
      className="relative flex h-10 min-w-0 max-w-full items-center gap-2 rounded-full border border-gray-200/70 bg-surface pl-3 pr-2.5 text-[13px] font-semibold text-gray-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 dark:border-gray-600/70 dark:bg-gray-870 dark:text-gray-100"
    >
      <span className="flex flex-none items-center">{resource ? getResourceIcon(resource, 'h-4 w-4') : <AnimationCircle size={4} />}</span>
      <span className="min-w-0 truncate">{name}</span>
      <ChevronDownIcon className="h-3.5 w-3.5 flex-none text-gray-400" aria-hidden="true" />
      {attention && <span className="absolute -right-0.5 -top-0.5 h-2.5 w-2.5 rounded-full bg-amber-500 ring-2 ring-surface dark:ring-gray-870" aria-hidden="true" />}
    </button>
  );
}
